import Api from './index.js';
import store from '@/store/index.js';

class Auth {

    /**
     * Request method to set default for login action.
     *
     * @param {Object} payload Data to be sent through request
     *
     * @return {Promise}
     */
    login(payload) {
        return Api.request('post', 'auth/login', payload, false)
            .catch(response => {
                return Promise.reject(response);
            })
            .then(response => {
                // Check for access token on success and store
                if(response.status === 200 && typeof response.data.access_token != 'undefined') {
                    this.storeToken(response.data.access_token);
                }

                return response;
            });
    }

    /**
     * Request logout for session removal.
     *
     * @return {Promise}
     */
    logout() {
        return Api.request('get', 'auth/logout', {}, false)
            .catch(response => {
                return Promise.reject(response);
            }).then(response => {
                // Remove token from localStorage and return response
                this.removeToken();
                this.reset();

                return response;
            });
    }

    /**
     * Return user state from vuex.
     *
     * @return {Object}
     */
    state() {
        return store.getters['user/state'];
    }

    /**
     * Reset vuex state back to original.
     *
     * @return {Void}
     */
    reset() {
        store.dispatch('user/resetState');
        return;
    }

    /**
     * Store user data into vuex.
     *
     * @param {Object} response User data response from API
     *
     * @return {Void}
     */
    store(data) {
        store.dispatch('user/updateEmail', data.email);
        store.dispatch('user/updateName', data.name);
        store.dispatch('user/updateAuthenticated', true);
        store.dispatch('user/updatePermissions', data.permissions);
        store.dispatch('user/updateAutino', data.autino);

        store.dispatch('locales/updateItems', data.locales);

        return;
    }

    /**
     * Request user data from API.
     *
     * @return {Promise}
     */
    me() {
        return Api.request('get', 'auth/me', {})
            .then(response => {
                // Store user data on success
                this.store(response.data);

                return response;
            })
            .catch(response => {
                return Promise.reject(response);
            });
    }

    /**
     * Request user token refresh.
     *
     * @return {Promise}
     */
    refresh() {
        return Api.request('post', 'auth/refresh', {}, false);
    }

    /**
     * Check if user is authenticated and/or if retrieving of data is needed.
     *
     * @return {Promise}
     */
    authenticated() {
        return new Promise((resolve, reject) => {
            // Set initial promise results
            let result = {
                fetch: false,
                success: false
            };

            // Check if user localStorage token exists
            if(this.getToken() != null) {
                // Then check if state is authenticated.
                if(!this.state().authenticated) {
                    // Request fetching if token exists without authentication.
                    result.fetch = true;
                    result.success = true;
                } else {
                    result.success = true;
                }
            }

            return resolve(result);
        });
    }

    /**
     * Store user token and update API axios instance headers.
     *
     * @param {String} token User token to be stored
     */
    storeToken(token) {
        // Update authorization header
        Api.setAuthorization(token);

        // Set new token in localStorage
        localStorage.setItem('token', token);
        return;
    }

    /**
     * Return JWT token from localStorage.
     *
     * @return {String}
     */
    getToken() {
        return localStorage.getItem('token');
    }

    /**
     * Remove JWT token from localStorage and update API headers.
     *
     * @return {Void}
     */
    removeToken() {
        // Unset token from API instance Authorization header
        Api.unsetAuthorization();

        // Remove JWT token from localStorage
        localStorage.removeItem('token');
        return;
    }

    /**
     * User is forbidden from accessing area.
     *
     * @return {Void}
     */
    forbidden(message) {
        let errors = [message];
        store.dispatch('updateErrors', errors);
    }

}

export default new Auth;



// WEBPACK FOOTER //
// ./src/api/auth.js